
















































































































































import { computed, defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { OptionToSelectOpt } from '~/utils/types/ProductPage';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getFirstPriceLabel, getSecondPriceLabel, getAdditionalPriceLabel, getHasScalapay } from '~/utils/helpers/product';
import { getOptionFirstlabel, getOptionSecondlabel } from '~/utils/solepro/prices';
import AddToCart from '~/components/solepro/AddToCart.vue';
import { CONFIGURABLE_TYPE_ID, DURATION_MATCHING, SIMPLE_TYPE_ID, TIPO_RINNOVO_AUTOMATICO, VIRTUAL_TYPE_ID } from '~/utils/constants/product';
import { getIsBook, isPaperOption } from '~/utils/solepro/products';
import QuantitySelector from './QuantitySelector.vue';
import PaymentFrequencySwitcher from './PaymentFrequencySwitcher.vue';
import { useConfig } from '~/composables';
import ClientOnly from 'vue-client-only';
import Teleport from 'vue2-teleport';
import accessibility from '~/utils/solepro/accessibility';
import CrossSellModal from '../CrossSellModal.vue';

export default defineComponent({
    props: {
        option: {
            type: Object as PropType<OptionToSelectOpt>
        },
        attributeCode: {
            type: String
        },
        product: {
            type: Object as PropType<ProductForProductPageType>,
            // required: true @TODO restore
        },
        
        suggestedSku:{
            type: String
        },
        showFrequencies:{
            type: Boolean,
            deafault: true
        },
        showSuggestedSku:{
            type: Boolean,
            deafault: false
        },
        useCarousel: {
            type: Boolean,
            default:false
        }
    },
    components: {
        AddToCart,
        QuantitySelector,
        PaymentFrequencySwitcher,
        ClientOnly,
        Teleport,
        CrossSellModal
    },
    data(){
        return {
            sprite: require('~/assets/solepro/spritemap.svg'),
        }
    },
    setup(props) {
        const { app: { i18n }, $fc } = useContext();
        const { product, option, attributeCode } = props;
        const isBook = getIsBook(product);
        const qty = ref(1);
        const paymentFrequencyChoosen = ref(product.entryBillingPeriod ?? product.paymentFrequencies[product.paymentFrequencies.length - 1])
        const crossSellModal = ref(null)

        const firstPriceLabel = ref()
        const secondPriceLabel = ref()
        const addictionalLabel = ref()
        const variant = ref(null);
        const attribute_uid = ref(null)
        const tmp = {}
        tmp[product.sku]={}
        const productConfiguration = ref(tmp)

        const lowFrequency = product.paymentFrequencies[0];
        const highFrequency = product.paymentFrequencies[1];
        const hasFrequencies = lowFrequency != highFrequency && !!highFrequency;

        if (product.productTypeId == CONFIGURABLE_TYPE_ID && attributeCode) {
            variant.value = product.variants.find(el => el.product[attributeCode] == option.value_index)
        }
        const priceLabels = computed(() => [firstPriceLabel.value, secondPriceLabel.value])

        const setLabels = () => {
            if (option && attributeCode) {
                firstPriceLabel.value = isBook && option.cost ? $fc(option.cost) : getOptionFirstlabel(product, { ...option, attribute_code: attributeCode }, paymentFrequencyChoosen.value, i18n, $fc)
                secondPriceLabel.value = isBook && option.cost ? 'prezzo IVA inclusa' : getOptionSecondlabel(product, { ...option, attribute_code: attributeCode }, paymentFrequencyChoosen.value, i18n, $fc)
            } else {
                /** @TODO set shipping costs */
                firstPriceLabel.value = getFirstPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc)
                const isVirtualRecurring = (product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO  && (product.productTypeId ==  VIRTUAL_TYPE_ID || product.productTypeId ==  SIMPLE_TYPE_ID))
                secondPriceLabel.value = getSecondPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc,0 ,0, isVirtualRecurring)
                addictionalLabel.value = getAdditionalPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc)

            }
        }

        const changeFrequency = (frequency) => {
            paymentFrequencyChoosen.value = frequency;
            /** check product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento') */
            const tipoAbbonamentoOptions = product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento')
            if (tipoAbbonamentoOptions) {
                variant.value = product.variants.find(el => DURATION_MATCHING[el.product.tipo_abbonamento] == frequency);
                if (tipoAbbonamentoOptions) {
                    attribute_uid.value = tipoAbbonamentoOptions.attribute_uid;
                    const option = tipoAbbonamentoOptions.values.find(el => DURATION_MATCHING[el.value_index] == frequency)
                    productConfiguration.value[product.sku][tipoAbbonamentoOptions.attribute_uid] = option.uid;
                }
            }
            setLabels()
        }

        

        // if is option selection the variant is automatically set, otherwise is set when the payment frequancy changes
        if (option && attributeCode) {
            const dm = DURATION_MATCHING
            variant.value = product.variants.find(el =>{
                const varValue = el.product[attributeCode].value ?? el.product[attributeCode];
                return varValue == option.value_index
                && ( !hasFrequencies || (hasFrequencies && dm[el.product.tipo_abbonamento] == paymentFrequencyChoosen.value))
            }).product;
            attribute_uid.value = product.configurable_options.find(el => el.attribute_code == attributeCode).attribute_uid
            productConfiguration.value[product.sku] =  {[attribute_uid.value]: option.uid } 
        } else changeFrequency(paymentFrequencyChoosen.value)


        const sanitizedSku=(variant.value && variant.value.sku ? variant.value.sku : product.sku).replace(/\./g,'').replaceAll(' ','-')
        const { config: storeConfig } = useConfig();
        const pdfModal = ref(null);
        const modalBtn = ref(null);
        
        return {
            hasScalapay: getHasScalapay(product) ,
            email: storeConfig.value.general_contact_email,
            sku: product.sku,
            variant,
            isPaper: isPaperOption(variant),
            title: attributeCode=='tipo_consegna' ? null: option?.label,
            subtitle: attributeCode=='tipo_consegna' ? option?.label : null,
            paymentFrequencyChoosen,
            firstPriceLabel,
            secondPriceLabel,
            addictionalLabel,
            productConfiguration,
            changeFrequency,
            isBook,
            qty,
            sanitizedSku,
            scalapaySelector: '["#campaign-price-container-secondary-'+sanitizedSku+'","#campaign-price-container-'+sanitizedSku+'"]',
            hasFrequencies,
            pdfModal,
            pdfModalId: 'pdf-modal',
            modalBtn,
            priceLabels
        }
    },
    mounted() {
        if(this.isBook && !this.isPaper){
            setTimeout(()=>{
                try { accessibility.accessibleModal(this.$refs.modalBtn as HTMLButtonElement) }
                catch (e) { console.warn('Pdf Modal not accessible. Error in Purchase Option Card -> accessibility.accessibleModal', e) }
            },0)
        }
    },
    methods: {
          openCrossSellModal() {
            // @ts-ignore
            if (this.$refs.crossSellModal && this.$refs.crossSellModal.openModal && this.$refs.crossSellModal.modalId) {
                // @ts-ignore
                this.$refs.crossSellModal.openModal(this.$refs.crossSellModal.modalId)
            }
        },
         adjustOverlay(overlay, isOpening = true) {
            if (isOpening) {
                overlay.classList.remove('z-10')
                overlay.classList.add('z-50')
            } else {
                overlay.classList.add('z-10')
                overlay.classList.remove('z-50')
            }
        },
       openPDFModal() {
            const modal = document.getElementById(this.pdfModalId)
            const overlay = document.getElementById('modal-backdrop');
            overlay.addEventListener("click", this.closeModalHandler)
            modal.addEventListener("keydown", this.keyDownHandler);
            // Add overlay before modal
            this.adjustOverlay(overlay)
            overlay.classList.remove('hidden');
            document.body.classList.add('modal-open');

            // Show modal
            modal.classList.add('show');

            setTimeout(() => {
                accessibility.simpleFocusTrap(modal)
            }, 500);
        },
         closePDFModal(keepOverlay: Boolean) {
            const modal = document.getElementById(this.pdfModalId);
            const overlay = document.getElementById('modal-backdrop');
            overlay.removeEventListener("click", this.closeModalHandler)
            modal.removeEventListener("keydown", this.keyDownHandler);
        
            this.adjustOverlay(overlay, false)
            if (!keepOverlay) overlay.classList.add('hidden');
            
            if (!modal) return;
            modal.classList.remove('show');

            document.body.classList.remove('modal-open');
        },
        changeQty(val) {
            const tmp = this.qty + val;
            if (tmp < 0) {
                this.qty = 0
            } else { this.qty = tmp }
            /**@TODO manage stock qty */

        },
         closeModalHandler(evt, keepOverlay?: Boolean) {
            this.closePDFModal(keepOverlay)
        },
        keyDownHandler(evt) {
            if (evt.key === "Escape") {
                this.closePDFModal(false);
            }
        }

    }
})
